import { Component, Input, OnInit } from '@angular/core';
import { Articulo } from '../interfaces/articulo.interface';
import { CartItem } from '../interfaces/car-item.interface';
import { ControlFacturacion } from '../interfaces/control-facturacion.interface';
import { RestService } from '../services/rest.service';
import { fixOrtography, esBuenFin, leyendaBuenfin, esCotizacionBuenFin, esCotizacionHotSale } from '../tools/tools';
import { CotizacionV1 } from '../interfaces/CotizacionesV1/CotizacionV1.interface';

@Component({
  selector: 'app-viewer-cotizacion-v1',
  templateUrl: './viewer-cotizacion-v1.component.html',
  styleUrls: ['./viewer-cotizacion-v1.component.css'],
})
export class ViewerCotizacionV1Component implements OnInit {
  @Input() centro: string;
  @Input() fecha: string;
  @Input() orderContent: CotizacionV1;
  openVideo = false;
  videoSleccionado = '';
  credit: boolean;
  cash: boolean;
  separated: boolean;
  folio: string;
  origin: number;
  title = 'cotizaciones';
  browser: string = window.navigator.userAgent;
  cargando = true;
  errorCarga = false;
  strLeyendaBf = leyendaBuenfin;
  esBF

  constructor(private restService: RestService) { }

  ngOnInit() {
    this.setupList();
  }

  setupList() {
    this.errorCarga = false;
    this.cargando = true;
    let cashTmp = false;
    let creditTmp = false;
    let separatedTmp = false;

    this.cargando = false;
    this.orderContent.cartItems.forEach(async (item: CartItem) => {
      if (item.precios[0].tipo_venta === 2) {
        cashTmp = true;
      }
      if (item.precios[0].tipo_venta === 4) {
        creditTmp = true;
      }
      if (item.precios[0].tipo_venta === 6) {
        separatedTmp = true;
      }
      if (!item.esLU) {
        const esKit: boolean = item.sku.slice(0) === 'K';
        const articulo: Articulo = {
          articulo: item.precios[0].articulo,
          centro: this.orderContent.idCentro,
          esLU: item.esLU,
          esKit,
          esOnline: false,
          tipoVenta: item.precios[0].tipo_venta,
        };
        try {
          item.otrosEsquemas = await this.getEsquemasArticulo(articulo);
        } catch (error) {
          this.errorCarga = true;
          this.cargando = false;
        }
      }
      // console.log('item', item);
      // console.log('SKU ' + item);
    });

    // console.log(this.orderContent.cartItems);

    this.cash = cashTmp;
    this.credit = creditTmp;
    this.separated = separatedTmp;
    this.cargando = false;
  }

  roundUp(value: number): number {
    return Math.ceil(value);
  }  

  sendVideoAction() {
    let strAction = 'NA';
    if (this.origin === 1) {
      strAction = 'openVideoFromMAIL';
    } else {
      strAction = 'openVideoFromSMS';
    }
    const action =
      '{ "idLandingPage": 8, ' +
      '"idToken": -1,' +
      '"folioCotizacion": "' +
      this.folio +
      '", ' +
      '"idAccionLandingPage": -1, ' +
      '"ip": "0.0.0.0", ' +
      '"navegador": "' +
      this.browser +
      '", ' +
      '"accion": "' +
      strAction +
      '", ' +
      '"validacionUsuario": false, ' +
      '"idOrigen": 17, ' +
      '"agente": -1 }';

    this.restService.sendAction(JSON.parse(action)).subscribe((result) => {
      // console.log('ACTION SENT');
      // console.log('RES: ' + JSON.stringify(result));
    });
  }

  fixOrtography(text: string) {
    return fixOrtography(text);
  }

  async getEsquemasArticulo(articulo: Articulo) {
    return new Promise<ControlFacturacion[]>((resolve, reject) => {
      this.restService.getConsultaEsquemasArticulo(articulo).subscribe(
        (resp) => {
          // console.log('Articulo', articulo);
          // console.log('Esquemas', resp);
          resolve(resp);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  tieneEsquemaBuenFin(
    esquemaCotizado: number,
    esquemas: ControlFacturacion[] = []
  ) {
    if (esquemaCotizado !== 28) {
      return false;
    }
    for (const esquema of esquemas) {
      if (esquema.control === 39 || esquema.control === 28) {
        return true;
      }
    }
    return false;
  }

  aplicaLineaA5(linea: string) {
    const lineasPara5 = [
      'Colchones  Línea I',
      'Calefactores Línea I',
      'Bóilers Línea I',
    ];

    if (lineasPara5.includes(linea)) {
      return true;
    }
    return false;
  }

  onClickOpenVideo(src: string): void {
    // console.log(src);

    this.openVideo = true;
    this.videoSleccionado = src;
  }

  onCloseVideo(): void {
    this.openVideo = false;
    this.videoSleccionado = '';
  }

  esCotizacionBf(fecha: string): boolean {
    // esBuenFin es un bool que se encuentra en tools.ts
    if (esBuenFin && esCotizacionBuenFin(fecha)) {
      this.esBF = true;
      return true;
    }
    return false
  }

  //esCotizacionHotSale

  esCotizacionHotSale(fecha: string): boolean {
    // esBuenFin es un bool que se encuentra en tools.ts
    if (esBuenFin && esCotizacionHotSale(fecha)) {
      this.esBF = true;
      return true;
    }
    return false
  }

  onImgError(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (!img.src.includes('imagen_no_disponible')) {
      img.src = 'assets/img/imagen_no_disponible.jpg';
    }
  }
}
